/**
 * Calculate the total cost of all copywriting items
 * @param {Object} controller - The data controller to access additionalOptions
 * @returns {number} Total copywriting cost in dollars
 */
export default function calculateTotalCopywritingCost(controller) {
  const additionalOptions = controller.get("data.scope.additionalOptions") || {}

  let totalCost = 0

  // Safety check to ensure additionalOptions is an object
  if (!additionalOptions || typeof additionalOptions !== "object") {
    return 0
  }

  // Iterate through all additional options to find copywriting sections
  Object.values(additionalOptions).forEach((section) => {
    // Check if this is a copywriting section
    if (section.type === "copywriting" && section.copywritingItems) {
      // Handle copywritingItems as an array (new structure)
      if (Array.isArray(section.copywritingItems)) {
        section.copywritingItems.forEach((item) => {
          if (item.enabled) {
            const pages = Number(item.pages) || 1
            const words = Number(item.words) || 0
            const ratePerWord = Number(item.ratePerWord) || 0.5
            totalCost += pages * words * ratePerWord
          }
        })
      } else {
        // Handle copywritingItems as an object (legacy structure)
        Object.values(section.copywritingItems).forEach((item) => {
          if (item.enabled) {
            const pages = Number(item.pages) || 1
            const words = Number(item.words) || 0
            const ratePerWord = Number(item.ratePerWord) || 0.5
            totalCost += pages * words * ratePerWord
          }
        })
      }
    }
  })

  return totalCost
}
